import { render, staticRenderFns } from "./EquipamentosModal.vue?vue&type=template&id=16efadf5"
import script from "./EquipamentosModal.vue?vue&type=script&lang=js"
export * from "./EquipamentosModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports